import Actions from './action';

export const initState = {
	atmLocationData: [],
	isAtmLoading: false,
	isAtmAccessTokenSuccess: false
};

const atmLocationReducer = (state = initState, action) => {

	switch (action.type) {

		case Actions.types.GET_ATM_ACCESS_TOKEN_SUCCESS: {
			return {
				...state,
				isAtmAccessTokenSuccess: true,
			};
		}

		case Actions.types.GET_ATMLOCATION_DATA_START: {
			return {
				...state,
				isAtmLoading: true,
			};
		}
		case Actions.types.GET_ATMLOCATION_DATA_SUCCESS: {
			console.log("SUCCESS", action.res.data.atmLocations)
			return {
				...state,
				isAtmLoading: false,
				atmLocationData: action.res.data.atmLocations,
			};
		}
		case Actions.types.GET_ATMLOCATION_DATA_ERROR: {
			return {
				...state,
				isAtmLoading: false,
			};
		}
		default:
			return state;
	}
};


export default atmLocationReducer;
